import React from 'react';

export default function Admin() {
  return (
    <div data-testid="admin-index">admin section</div>
  );
}
